

import hardware_pic2 from "./imgs/hardware_pic2.png";
import hardware_pic3 from "./imgs/hardware_pic3.png";
import hardware_pic4 from "./imgs/hardware_pic4.png";
import hardware_pic5 from "./imgs/hardware_pic5.png";
import hardware_pic6 from "./imgs/hardware_pic6.png";
import hardware_pic7 from "./imgs/hardware_pic7.png";
import hardware_pic8 from "./imgs/hardware_pic8.png";
const p3List = [
  {
    title: "企业数字前台",
    tags: ["访客通知", "企业宣传", "互动问答"],
    desc: "告别传统前台的千篇一律，数字前台一体机让企业分分钟拥有一个7x24小时全天候“超能员工”，3秒迎宾、自动通知、位置指引、企业宣传，全搞定，更重要的是“0情绪、0请假、0流失”、“高颜值！高情商！高效率！”",
    img: hardware_pic2,
  },
  {
    title: "展厅数字导览",
    tags: ["路线规划", "展品互动", "智能问询"],
    desc: '可移动透明屏OLED，厘米级激光 SLAM 自主导航，展厅全域精准定位；到达即开讲，4K 超清数字人全息呈现，专业级定点讲解，声画同步、多语种切换；内置千亿参数大模型，实时语义理解，观众随问随答，全面升级展厅参观体验。',
    img: hardware_pic3,
  },
  {
    title: "政务数字客服",
    tags: ["导办帮办", "政策宣讲", "综合咨询"],
    desc: '主动迎宾后，根据办事人需求推送办事指南、材料清单，实现“一对一”沉浸式引导，7×24 小时替代窗口咨询员，实时回答服务大厅高频业务问题，答复准确率≥95%，群众排队时间平均缩短 40%。',
    img: hardware_pic4,
  },
  {
    title: "零售数字导购",
    tags: ["秒级迎宾", "智能导购", "数据反哺"],
    desc: '把金牌导购装进一块屏，插电即用，7×24 小时在线迎宾、讲解、推款、收银一手包办；顾客靠近秒唤醒，语音+触屏三问锁定需求，连带率立涨 50%；一台机器，省下全年人力。',
    img: hardware_pic5,
  },
  {
    title: "银行数字网点",
    tags: ["迎宾取号", "业务咨询", "产品讲解"],
    img: hardware_pic6,
    desc: 'AI数字人一体机进驻银行网点，秒变“超级大堂经理”：迎宾、取号、业务咨询、产品讲解、营销推荐一机搞定，分流60%柜面压力，7×24小时在岗，人力降一半，体验升一级。'
  },
  {
    title: "商务数字展会",
    tags: ["3秒注册", "会场导览", "参展规划"],
    img: hardware_pic7,
    desc: '专为高端会务、行业展会打造的“展灵”AI数字人一体机，让嘉宾进门3秒完成注册，问询一句话直达展位，展会服务从人海战术升级为单点智能，主办省心、嘉宾爽心。'
  },
  {
    title: "医院数字导诊",
    tags: ["一站式预检", "智能分诊", "7×24 值守"],
    img: hardware_pic8,
    desc: '数字医生秒级识别，预检+挂号+导航一体化，AI分诊 3000+症状，挂错号直降50%，7×24值守，分流护士 60% 压力，医护减负、就医提速。'
  },
];
const data = {
  p1: {
    title: "智能交互一体机",
    subtitle: "不只是“一块屏”，看得见、听得懂、会互动",
    link: "",
  },
  p2: {
    title: "产品优势",
    list: [
      [
        {
          title: "三位一体，智能融合",
          icon: "p2Icon1",
          index: 1,
          list: [
            { label: "数字人形象：", desc: "高清拟真外形，支持企业定制" },
            { label: "大模型驱动：", desc: "多种大语言模型，智能应答" },
            { label: "屏显终端集成：", desc: "一体化硬件设计，部署便捷" }
          ]
        },
        {
          title: "一键上岗，零培训",
          icon: "p2Icon3",
          index: 3,
          list: [
            { label: "", desc: "产品部署无需复杂培训，支持开机即用" },
            { label: "", desc: "支持快速导入企业知识库，学习自适应" },
            { label: "", desc: "多轮对话逻辑清晰，服务流程标准化" }
          ]
        }
      ],
      [
        {
          title: "超长待机，高可用",
          icon: "p2Icon2",
          index: 2,
          list: [
            { label: "", desc: "7×24小时在线" },
            { label: "", desc: "情绪稳定、响应快速" },
            { label: "", desc: "降低人力成本，释放员工价值" }
          ]
        },
        {
          title: "主动交互，智能引导",
          icon: "p2Icon4",
          index: 4,
          list: [
            { label: "", desc: "主动问询，个性化打招呼" },
            { label: "", desc: "支持语音、触控、视觉等多模态交互" },
            { label: "", desc: "提供多语言服务，适配多元化用户群体" }
          ]
        }
      ]
    ]
  },
  p3: {
    title: "应用场景",
    list: p3List
  }
};
export default data;